import { showErrorAction, clearErrorAction } from "WorkCustomization/Scripts/Common/Actions/MessageBarActions";
import { ProcessFieldUsageData, ProcessDefinitionFieldUsageData, ProcessWorkItemType } from "Admin/Scripts/Contracts/TFS.Admin.Process.Contracts";
import * as ProcessContracts from "TFS/WorkItemTracking/ProcessContracts";
import { WebAccessBoardsWITDataSource } from "Presentation/Scripts/TFS/MVCToDataProviderDataSources/MVCToDataProviderDataSource";
import { IRouteParams, IDataSourceResponse } from "Presentation/Scripts/TFS/MVCToDataProviderDataSources/WITDataSource";
import Q = require("q");
import { Action } from "VSS/Flux/Action";

export interface IWorkItemFieldsLoadedPayload {
    processId: string;
    processDefinitionFieldUsageData: ProcessDefinitionFieldUsageData;
}

export const workItemFieldsLoadedAction = new Action<IWorkItemFieldsLoadedPayload>();

export namespace WorkItemFieldsActionCreator {

    export function beginGetWorkItemFieldUsageData(processId: string): IPromise<ProcessDefinitionFieldUsageData> {
        const routeParams: IRouteParams = { controller: "process", action: "GetProcessFieldUsages" };
        const deferred: Q.Deferred<ProcessDefinitionFieldUsageData> = Q.defer<ProcessDefinitionFieldUsageData>();

        new WebAccessBoardsWITDataSource().getDataAsync<string>(routeParams, { processTypeId: processId })
            .then((witDataSourceResponse: IDataSourceResponse<string>) => {
                const processFieldUsageData: ProcessFieldUsageData = JSON.parse(witDataSourceResponse.data) as ProcessFieldUsageData;
                clearErrorAction.invoke(null);

                // convert from mvc to webapi
                const processDefinitionFieldUsageData = ProcessFieldUsageConverter.toProcessDefinitionFieldUsageData(processFieldUsageData);
                workItemFieldsLoadedAction.invoke({
                    processId,
                    processDefinitionFieldUsageData
                });

                deferred.resolve(processDefinitionFieldUsageData);
            }, error => showErrorAction.invoke({ errorMessage: error.message }));

        return deferred.promise;
    }
}

export namespace ProcessFieldUsageConverter {
    export function toProcessDefinitionFieldUsageData(fieldUsageData: ProcessFieldUsageData): ProcessDefinitionFieldUsageData {
        const workItemTypes: ProcessContracts.ProcessWorkItemType[] = fieldUsageData.WorkItemTypes.map((workItemType) => {
            return _toProcessWorkItemTypeModel(workItemType);
        });

        return {
            Fields: fieldUsageData.Fields,
            WorkItemTypes: workItemTypes
        };
    }

    function _toProcessWorkItemTypeModel(workItemType: ProcessWorkItemType): ProcessContracts.ProcessWorkItemType {
        const customization = _toCustomizationType(workItemType);
        // MVC populates ParentWorkItemTypeId for both Custom and Derived classes, but WebApi
        // only sets inherits if Derived.
        const inherits = customization === ProcessContracts.CustomizationType.Inherited ? workItemType.ParentWorkItemTypeId : null;

        return {
            referenceName: workItemType.Id,
            name: workItemType.Name,
            description: workItemType.Description,
            color: workItemType.Color,
            customization: customization,
            inherits: inherits,
            isDisabled: workItemType.IsDisabled,
            layout: workItemType.Layout,
            behaviors: null,
            icon: null,
            states: null,
            url: null
        };
    }

    function _toCustomizationType(workItemType: ProcessWorkItemType): ProcessContracts.CustomizationType {
        if (workItemType.IsCustomType) {
            return ProcessContracts.CustomizationType.Custom;
        }
        else if (workItemType.ParentWorkItemTypeId) {
            return ProcessContracts.CustomizationType.Inherited;
        }
        else {
            return ProcessContracts.CustomizationType.System;
        }
    }
}
